var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "modal-dialog" }, [
    _c("div", { staticClass: "modal-content" }, [
      _vm.options.modalTitle
        ? _c("div", { staticClass: "modal-header" }, [
            _c("h4", { staticClass: "modal-title" }, [
              _vm._v(_vm._s(_vm.options.modalTitle)),
            ]),
            _vm._v(" "),
            _c("button", {
              staticClass: "btn-close",
              attrs: { "aria-label": "Close", type: "button" },
              on: {
                click: function ($event) {
                  return _vm.$emit("hide-modal")
                },
              },
            }),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "modal-body" }, [
        _c("div", { domProps: { innerHTML: _vm._s(_vm.options.modalBody) } }),
        _vm._v(" "),
        _setup.confirmStr
          ? _c(
              "form",
              {
                on: {
                  submit: function ($event) {
                    $event.preventDefault()
                    return _setup.onSubmit.apply(null, arguments)
                  },
                },
              },
              [
                _c("p", { staticClass: "mt-3" }, [
                  _vm._v("\n                    Please type "),
                  _c("strong", [_vm._v(_vm._s(_setup.confirmStr))]),
                  _vm._v(" to confirm.\n                "),
                ]),
                _vm._v(" "),
                _c("p", [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _setup.input,
                        expression: "input",
                      },
                      { name: "select", rawName: "v-select" },
                      { name: "focus", rawName: "v-focus" },
                    ],
                    staticClass: "form-control",
                    attrs: { autocomplete: "off", type: "text" },
                    domProps: { value: _setup.input },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _setup.input = $event.target.value
                      },
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("p", [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-danger mt-2 w-100",
                      attrs: { disabled: _setup.isDisabled },
                    },
                    [
                      _vm._v(
                        "\n                        I understand the consequences, confirm delete.\n                    "
                      ),
                    ]
                  ),
                ]),
              ]
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      !_setup.confirmStr
        ? _c(
            "div",
            { staticClass: "modal-footer text-end" },
            [
              _c(
                _setup.Button,
                {
                  nativeOn: {
                    click: function ($event) {
                      return _vm.$emit("hide-modal")
                    },
                  },
                },
                [_vm._v("Cancel")]
              ),
              _vm._v(" "),
              _c(
                _setup.Button,
                {
                  directives: [{ name: "focus", rawName: "v-focus" }],
                  attrs: { "default-class": "btn-warning" },
                  nativeOn: {
                    click: function ($event) {
                      return _setup.onSubmit.apply(null, arguments)
                    },
                  },
                },
                [_vm._v("\n                OK\n            ")]
              ),
            ],
            1
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }